<template>
  <div v-if="application_status.loaded">
    <div v-if="docs.length > 0">
      <div
        class="upload-link-right"
        v-if="applicant && applicant.client_document_requests_link"
      >
        <div>
          <span>Upload Link:</span>
          <span title="Click to go to upload page">
            <a
              :href="applicant.client_document_requests_link.short_link"
              target="_blank"
              >{{ applicant.client_document_requests_link.short_link }}</a
            >
          </span>
          <span title="Click to copy URL">
            <a
              href="#"
              @click="
                copyLink(applicant.client_document_requests_link.short_link)
              "
              ref="copyLink"
            >
              <i class="material-icons text_align-center">content_copy</i>
            </a>
          </span>
        </div>
      </div>
      <div class="upload-link-right" v-else>
        <p>Upload Link: To generate, please send a request to the applicant.</p>
      </div>

      <table class="data-table wide">
        <thead>
          <tr>
            <th><code>Document</code></th>
            <th class="right"><code>Verified</code></th>
            <th class="right"><code>Requested</code></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="document_request in docs"
            :key="String(document_request.id)"
            v-show="document_request.showhide"
          >
            <td>
              <span :title="document_request.description">{{
                document_request.name
              }}</span>
            </td>
            <td class="right">
              <md-checkbox
                v-model="document_request.verified"
                class="no-md-input-margin"
                disabled="disabled"
              />
            </td>
            <td class="right">
              <md-checkbox
                v-model="document_request.requested"
                class="no-md-input-margin"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <md-button
        class="md-primary md-sm"
        @click="showhidedocs()"
        :disabled="isLoading"
      >
        {{ button.text }}
      </md-button>
      <v-textarea
        outlined
        background-color="grey lighten-2"
        color="cyan"
        label="Comment"
        v-model="new_comment.content"
      >
      </v-textarea>

      <md-button
        class="md-primary md-sm"
        @click="sendEmail(false)"
        :disabled="isLoading"
      >
        Save & Send Email
      </md-button>

      <md-button
        class="md-primary md-sm"
        @click="sendSms()"
        :disabled="isLoading"
      >
        Save & Send SMS
      </md-button>

      <md-button
        v-if="applicant.document_requests"
        class="md-primary md-sm"
        @click="sendEmail(true)"
        :disabled="isLoading"
      >
        Generate Link
      </md-button>
      <md-button
        class="md-primary md-sm"
        @click="sendWalletSms()"
        :disabled="isLoading"
      >
        Send Wallet Link SMS
      </md-button>
      <span class="loading_icon_position">
        <md-progress-spinner
          :md-diameter="17"
          :md-stroke="2"
          v-if="isLoading"
          md-mode="indeterminate"
          class="no-fade-out"
        />
      </span>

      <md-dialog-alert
        :md-active.sync="error_dialog.show"
        :md-title="error_dialog.title"
        :md-content="error_dialog.content"
      />
    </div>
  </div>
  <div v-else>
    <md-empty-state
      md-icon="hourglass_empty"
      md-label="Loading"
      md-description="Please wait whilst the application is loading"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import { ValidatedTextInput } from "@/components";

// Vuetify
import vuetify from "../../vuetify";

export default {
  data() {
    return {
      error_dialog: {
        show: false,
        title: "",
        content: "",
      },
      new_comment: {
        tag: "Applicant 1 - Send Comments With Document Requests",
        content: "",
        completed: false,
        name: {
          first_name: "",
          last_name: "",
        },
      },
      loading: false,
      alwaysShowDocs:[
        'Medicare Card',
        'Recent Payslip 1',
        'Recent Payslip 2',
        'Drivers licence front',
        'Drivers licence back',
        '3 Months Bank Statements (Link)',
        '6 Months Bank Statements (Link)',
        'Privacy Consent Online'
      ],
      docs:[],
      button : { text : 'Show More'}
    };
  },
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    ValidatedTextInput,
    vuetify,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    application: {
      type: Object,
      required: true,
    },
    index: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    ...mapGetters(["options", "application_status"]),

    applicant: {
      get() {
        return this.value;
      },
      set(applicant) {
        this.$emit("input", applicant);
      },
    },

    isLoading: {
      get() {
        return this.loading;
      },
      set(loading) {
        this.loading = loading;
        this.$emit("loading", loading);
      },
    },

    applicants() {
      return this.application.applicants;
    },
  },
  mounted(){
    this.getDocumentRequests();
  },
  watch: {
    'applicant.id': {
      handler() {
        this.getDocumentRequests();
      }
    },
  },
  methods: {
    showDialogPopup(title, message) {
      this.error_dialog.title = title;
      this.error_dialog.content = message;
      this.error_dialog.show = true;
    },
    getDocumentRequests() {
      let document_request_obj = [];
      if (
        this.applicant.document_requests &&
        this.applicant.document_requests.length
      ) {
        for (let i = 0; i < this.applicant.document_requests.length; i++) {

          if (this.applicant.document_requests[i].is_request == 1) {
            this.applicant.document_requests[i].showhide = true;
            if(this.alwaysShowDocs.indexOf(this.applicant.document_requests[i].description) == -1) {
              this.applicant.document_requests[i].showhide = false;
            }
            document_request_obj.push(this.applicant.document_requests[i]);
          }
        }
      }
      this.docs = document_request_obj;
    },
    async sendEmail(onlyGenerateLink = false) {
      this.save_document_comment();
      this.isLoading = true;
      try {
        await this.$store.dispatch("request_documents_via_email", {
          application_data: this.application,
          applicantId: this.applicant.id,
          document_requests: this.docs,
          generateLink: onlyGenerateLink,
        });
        this.isLoading = false;

        //message popup once email has been sent and spinner stops.
        if (!onlyGenerateLink) {
          this.showDialogPopup(
            "Document Request Email Sent",
            "Document request email has been sent to the applicant."
          );
        }
      } catch (error) {
        console.error("send email request failed");
        console.error(error);
        this.isLoading = false;

        //message popup if email send fails and spinner stops.
        this.showDialogPopup(
          "Failed Sending Email",
          '<span style="color:red;font-weight:bold;">Please check all fields are valid and save the application before retrying. Contact support if issue persists.</span>'
        );
      }
      this.isLoading = false;
    },

    async sendSms() {

      this.save_document_comment();
      this.isLoading = true;
      try {
        await this.$store.dispatch("request_documents_via_sms", {
          application_data: this.application,
          applicantId: this.applicant.id,
          generateLink:true,
        });

        //message popup once sms has been sent and spinner stops.
          this.showDialogPopup(
            "Document Request SMS Sent",
            "Document request SMS has been sent to the applicant."
          );
      } catch (error) {
        console.error("send SMS request failed");
        console.error(error);

        //message popup if sms send fails and spinner stops.
        this.showDialogPopup(
          "Failed Sending SMS",
          '<span style="color:red;font-weight:bold;">Please check all fields are valid and save the application before retrying. Contact support if issue persists.</span>'
        );
      }
      finally {
        this.isLoading = false;
      }
    },

    async sendWalletSms() {
      this.isLoading = true;
      // [0] Mobile
      const mobilePhone = this.applicant.contact.phones[0].phone_number;
      const applicantId = this.applicant.id;

      if(!mobilePhone) {
        this.isLoading = false;
        this.showDialogPopup(
          "Failed Sending SMS",
          '<span style="color:red;font-weight:bold;">User must have a mobile phone number.</span>'
        );
      } else {
        try {
          //
          let {
            data: response
          } = await axios.post(`/api/v1/applicant/${applicantId}/wallet/sms`);

          //message popup once sms has been sent and spinner stops.
          this.showDialogPopup(
              "Wallet link via SMS Sent",
          );
          return response;
        } catch (error) {
          console.error("Send Wallet link SMS request failed");
          console.error(error);

          //message popup if sms send fails and spinner stops.
          this.showDialogPopup(
            "Failed Sending Wallet link SMS",
            '<span style="color:red;font-weight:bold;">Please check all fields are valid and save the application before retrying. Contact support if issue persists.</span>'
          );
        }
        finally {
          this.isLoading = false;
        }
      }
    },

    async copyLink(link) {
      await navigator.clipboard.writeText(link);
      this.showDialogPopup(
        "Upload Page Url has been copied to clipboard",
        `Upload Page Url - ${link} has been copied to the clipboard`
      );
    },
    load_comment_text() {
      for (let i = 0; i < this.application.loan.comments.length; i++) {
        if (
          this.application.loan.comments[i].tag ==
          "Applicant " + this.index + " - Send Comments With Document Requests"
        ) {
          this.new_comment.content = this.application.loan.comments[i].content;
        }
      }
    },

    save_document_comment() {
      if (this.new_comment.content) {
        this.application.loan.comments.push(this.new_comment);
      }
    },
    showhidedocs () {
      let document_request_obj = [];
      if (this.docs && this.docs.length) {
        for (let i = 0; i < this.docs.length; i++) {
          if (this.docs[i].is_request == 1) {
            if (this.alwaysShowDocs.indexOf(this.docs[i].description) == -1) {
              this.docs[i].showhide = !this.docs[i].showhide ;
            }
            document_request_obj.push(this.docs[i]);
          }
        }
      }
      this.docs = document_request_obj;
      this.button.text = (this.button.text == 'Show More') ? 'Show Less' : 'Show More' ;
    }
  },
};

</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.no-md-input-margin {
  margin: 0px;
}

.loading_icon_position {
  top: 10px;
  position: relative;
  left: 10px;
}

.upload-link-right {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.upload-link-right a {
  margin-left: 15px;
}
code {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}
</style>
